import { useEffect, useRef } from "react";
import scrollReveal from "scrollreveal";

export default function ScrollReveal({
                                       children,
                                       direction = "up",
                                       delay = 0,
                                       distance = "50px",
                                       duration = 800,
                                     }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    scrollReveal().reveal(ref.current, {
      origin: direction,
      distance,
      duration,
      delay,
      easing: "ease-out",
      cleanup: true,
    });
  }, [direction, delay, distance, duration]);

  return <div ref={ref}>{children}</div>;
}
